export const ticketsVideoData = [
    {
        src: "https://www.youtube.com/embed/aFILr_KqZfQ?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №1",
    },
    {
        src: "https://www.youtube.com/embed/pRO6F1LyRj4?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №2",
    },
    {
        src: "https://www.youtube.com/embed/OmZsF29unOs?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №3",
    },
    {
        src: "https://www.youtube.com/embed/xEQWV27LDLs?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №4",
    },
    {
        src: "https://www.youtube.com/embed/OYgcrXdXbb0?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №5",
    },
    {
        src: "https://www.youtube.com/embed/mdLG4-QQc8s?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №6",
    },
    {
        src: "https://www.youtube.com/embed/4ztRCpG6L0w?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №7",
    },
    {
        src: "https://www.youtube.com/embed/S73VpcvRz-w?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №8",
    },
    {
        src: "https://www.youtube.com/embed/43dX8w1dIGs?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №9",
    },
    {
        src: "https://www.youtube.com/embed/0RX8Q8iyvKw?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №10",
    },
    {
        src: "https://www.youtube.com/embed/onu3n4xba2s?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №11",
    },
    {
        src: "https://www.youtube.com/embed/ee1jV3KATh0?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №12",
    },
    {
        src: "https://www.youtube.com/embed/z0_MVi3s7Ts?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №13",
    },
    {
        src: "https://www.youtube.com/embed/1sNiG-Qw2hM?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №14",
    },
    {
        src: "https://www.youtube.com/embed/C3zpKp-Af10?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №15",
    },
    {
        src: "https://www.youtube.com/embed/_vpE_74nH_Q?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №16",
    },
    {
        src: "https://www.youtube.com/embed/pz-6l3IQKMY?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №17",
    },
    {
        src: "https://www.youtube.com/embed/5w-MXJWx6SI?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №18",
    },
    {
        src: "https://www.youtube.com/embed/XS7XrONqv7E?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №19",
    },
    {
        src: "https://www.youtube.com/embed/W1sn-Ad8l7A?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №20",
    },
    {
        src: "https://www.youtube.com/embed/C0mC5_PxtGE?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №21",
    },
    {
        src: "https://www.youtube.com/embed/gesJaWll-l8?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №22",
    },
    {
        src: "https://www.youtube.com/embed/Ubd8r3IhhuI?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №23",
    },
    {
        src: "https://www.youtube.com/embed/bf2d8JZb3qs?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №24",
    },
    {
        src: "https://www.youtube.com/embed/OPzKDnurNd4?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №25",
    },
    {
        src: "https://www.youtube.com/embed/gR9INzf-mGU?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №26",
    },
    {
        src: "https://www.youtube.com/embed/_dj7-YjjVfc?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №27",
    },
    {
        src: "https://www.youtube.com/embed/ypcsnoq5H-0?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №28",
    },
    {
        src: "https://www.youtube.com/embed/FXfJA_TrC4E?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №29",
    },
    {
        src: "https://www.youtube.com/embed/jF79kcRXXJE?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №30",
    },
    {
        src: "https://www.youtube.com/embed/hQ2AnZpX34s?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №31",
    },
    {
        src: "https://www.youtube.com/embed/6302QjJFCQA?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №32",
    },
    {
        src: "https://www.youtube.com/embed/zOCV1lDuitE?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №33",
    },
    {
        src: "https://www.youtube.com/embed/4SDgXG828J4?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №34",
    },
    {
        src: "https://www.youtube.com/embed/hC4pYkle_vA?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №35",
    },
    {
        src: "https://www.youtube.com/embed/cnJo_yVxdr8?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №36",
    },
    {
        src: "https://www.youtube.com/embed/V-3nON5qUWU?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №37",
    },
    {
        src: "https://www.youtube.com/embed/2BuKcf6Xbbc?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №38",
    },
    {
        src: "https://www.youtube.com/embed/JT4VhjqoqqE?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №39",
    },
    {
        src: "https://www.youtube.com/embed/wRKFiPWI-vU?list=PLAWcAWvbdq56ykWQzkGeXtQ258h9WtRmC",
        title: "Разбор билетов ПДД | Билет №40",
    },
];
